import { type TransactionsFilterInput, useGetTransactionsQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { transactionsColumns, type TransactionRow } from '../constants/transactionsColumns';

// Les liens « voir plus » (`?userIds=` depuis une fiche utilisateur, `?siteIds=` depuis une fiche site) visent des
// filtres déclarés : la `DataTable` les relit dans l'URL et les affiche en puces, levables comme les autres.
export const TransactionsList = () => {
    const {
        loading: transactionsLoading,
        data: transactionsData,
        error: transactionsError,
        refetch,
        fetchMore,
    } = useGetTransactionsQuery({
        // `filters`, `sortBy` et `sortOrder` sont dans les `keyArgs` de la field policy `transactions` : les omettre
        // ici alors que le scroll infini les envoie (`filters: {}` sans filtre) ferait écrire `fetchMore` dans une
        // AUTRE entrée de cache que celle lue par le composant — pages chargées, rien qui s'ajoute. Ils doivent
        // refléter l'état initial de la table.
        variables: { filters: {}, sortBy: 'createdAt', sortOrder: 'desc' },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (transactionsError) {
        throw new Error('Une erreur est survenue lors de la récupération des transactions');
    }

    const hasMore = transactionsData?.transactions.hasMore ?? false;
    const transactions = transactionsData?.transactions.transactions ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<TransactionRow, TransactionsFilterInput>
                columns={transactionsColumns}
                data={transactions}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/transaction/${row._id}`}
                hasMore={hasMore}
                isLoading={transactionsLoading}
                refetch={refetch}
                fetchMore={fetchMore}
                defaultSortBy="createdAt"
                defaultSortOrder="desc"
                searchPlaceholder="ID de la transaction"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
